import type { NetworkStatus, PWAStatus } from '@lilith-arcana-os/domain';

export interface PwaRegistrationCallbacks {
  onNetworkStatusChange?: (status: NetworkStatus) => void;
  onPwaStatusChange?: (status: PWAStatus) => void;
}

export const registerPwa = async (
  enabled: boolean,
  callbacks: PwaRegistrationCallbacks = {},
): Promise<void> => {
  const updateNetworkStatus = () => {
    callbacks.onNetworkStatusChange?.(navigator.onLine ? 'online' : 'offline');
  };

  window.addEventListener('online', updateNetworkStatus);
  window.addEventListener('offline', updateNetworkStatus);
  updateNetworkStatus();

  if (!enabled || !('serviceWorker' in navigator)) {
    callbacks.onPwaStatusChange?.('unsupported');
    return;
  }

  const currentScope = window.location.pathname.endsWith('/')
    ? window.location.pathname
    : `${window.location.pathname}/`;

  try {
    await navigator.serviceWorker.register('/lilith-arcana-sw.js', {
      scope: currentScope,
    });
    callbacks.onPwaStatusChange?.('installed');
  } catch (_error) {
    callbacks.onPwaStatusChange?.('idle');
  }
};
